import Select from 'react-select';
import { FC, useState } from "react"
import { Button, Modal, Spinner } from "react-bootstrap-v5"
import ApiCalls from "../../../network/ApiCalls"
import { AxiosResponse } from 'axios';
import { useQuery } from 'react-query';
import { DeclineNotesEnum } from '../../../enums/DeclineNoteEnums'
import { TextInput } from '../../../umut-components/Inputs/TextInput';
import { StaffPendingRequest } from '../../../network/PostRequestModels';
import { Margin } from 'devextreme-react/bar-gauge';
import { Width } from 'devextreme-react/chart';

type Props = {
  show: Boolean
  handleClose: () => void
  refetch: () => void
  data: any
}


const PendingCheckDialog: FC<Props> = ({ show, handleClose, data, refetch }) => {
  const [loading, setLoading] = useState(false)


  const handleConfirmation = async () => {
    try {
      if (data) {
        setLoading(true)
        let request: StaffPendingRequest = {
          userId: data.data.userId,
          accountStatusId: data.statusId,

        }
        await ApiCalls.declineVendorStaffStatus(request)
        setLoading(false)
        refetch()
        handleClose()
      }
    } catch (error) {
      setLoading(false)
    }
  }
  const handleCloseModal = () => {
    handleClose()
  }


  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Staff Verification</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        Are you sure you want to approve the staff?
      </Modal.Body>
      <Modal.Footer>
      <button type='button' className='btn btn-light' onClick={handleCloseModal} >
          Cancel
        </button>
        <Button className="btn btn-success" disabled={loading} onClick={handleConfirmation}>Approve {loading ? <Spinner animation='border' size='sm' /> : null}</Button>
      
      </Modal.Footer>
    </Modal>
  )
}

export default PendingCheckDialog
